module.exports = {
      id: "hamburger_search-usage",
      viewBox: "0 0 35 23",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#hamburger_search",
      toString: function () {
        return this.url;
      }
    }